import { Component } from '@angular/core';
import { SelectCityService } from '../../../shared-services/select-city/select-city.service';

@Component({
  selector: 'app-footer-agent',
  templateUrl: './footer-agent.component.html',
  styleUrl: './footer-agent.component.scss'
})
export class FooterAgentComponent {
  constructor(private cityService: SelectCityService) {}

  openSelectCity(): void {
    this.cityService.openSelectCity();
  }
}
